import jinx from '../images/design/jinx.png'
import saebyok from '../images/design/saebyok.png'
import person from '../images/design/chipaawm.png'
import karina from '../images/design/karina.png'
import totorornd from '../images/design/totorornd.png'

const design = [
    {
        id: 1,
        img: jinx,
        title: 'Jinx',
        cat: 'Digital Illustration',
        tool: 'Clip Studio Paint',
        year: 2021,
    },
    {
        id: 2,
        img: saebyok,
        title: 'Player 067',
        cat: 'Digital Illustration',
        tool: 'Clip Studio Paint',
        year: 2021,
    },
    {
        id: 3,
        img: totorornd,
        title: 'Totoro',
        cat: 'Digital Illustration',
        tool: 'Clip Studio Paint',
        year: 2021,
    },
    {
        id: 4,
        img: person,
        title: 'Person',
        cat: 'Digital Illustration',
        tool: 'Clip Studio Paint',
        year: 2021,
    },
    {
        id: 5,
        img: karina,
        title: 'Karina',
        cat: 'Digital Illustration',
        tool: 'Clip Studio Paint',
        year: 2021,
    },
];

export default design;